declare global {
  interface Window {
    dataLayer: any[];
  }
}

interface PageViewParams {
  pagePath: string;
  pageTitle?: string;
  sessionId?: string;
  trafficSource?: string;
  customData?: Record<string, unknown>;
}

export const initDataLayer = () => {
  if (typeof window === "undefined") return;
  if (!window.dataLayer) {
    window.dataLayer = [];
  }
};

export const pushToDataLayer = (event: Record<string, unknown>) => {
  if (typeof window === "undefined") return;
  initDataLayer();
  window.dataLayer.push(event);
};

export const trackPageViewGTM = ({
  pagePath,
  pageTitle,
  sessionId,
  trafficSource,
  customData = {},
}: PageViewParams) => {
  if (typeof window === "undefined") return;

  const title = pageTitle || document.title;

  pushToDataLayer({
    event: "virtual_page_view",
    page_path: pagePath,
    page_title: title,
    page_location: window.location.href,
    traffic_source: trafficSource || "direct",
    session_id: sessionId,
    ...customData,
  });
};

export const trackEventGTM = (
  eventName: string,
  eventParams?: Record<string, unknown>
) => {
  pushToDataLayer({
    event: eventName,
    ...(eventParams || {}),
  });
};

export const getOrCreateSessionId = (): string => {
  const storageKey = "sessionId";
  if (typeof window === "undefined") {
    // Fallback for non-browser environments
    return `session_${Date.now()}`;
  }

  let sessionId = window.localStorage.getItem(storageKey);
  if (!sessionId) {
    sessionId = `session_${Date.now()}_${Math.random()
      .toString(36)
      .substring(2, 15)}`;
    window.localStorage.setItem(storageKey, sessionId);
  }
  return sessionId;
};


